import React from "react";
import styles from "~/pages/CharacterSheet/widgets/ProfileSection/ProfileSection.scss";
import ProfileCard from "~/pages/CharacterSheet/widgets/ProfileCard/ProfileCard";

export interface ProfileSectionProps {
  appearance: string;
  notes: string;
  onAppearanceChange: (appearance: string) => void;
  onNotesChange: (notes: string) => void;
}

const ProfileSection: React.FC<ProfileSectionProps> = ({
  appearance,
  notes,
  onAppearanceChange,
  onNotesChange,
}) => {
  return (
    <section className={styles.profileSection}>
      <div className={styles.profileHeader}>
        <h3 className={styles.sectionTitle}>Profile</h3>
      </div>
      <div className={styles.profileGrid}>
        <ProfileCard
          title="Appearance"
          content={appearance}
          placeholder="No appearance set. Double-click or press Edit to add."
          editingPlaceholder="Describe physical appearance, distinctive features..."
          onChange={onAppearanceChange} />
        <ProfileCard
          title="Notes"
          content={notes}
          placeholder="No notes set. Double-click or press Edit to add."
          editingPlaceholder="Backstory, personality, goals, secrets..."
          onChange={onNotesChange} />
      </div>
    </section>
  );
};

export default ProfileSection;
